import { Trans, useTranslation } from "react-i18next";

import type { ModuleDependency } from "../types";

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/v2/alert-dialog";

interface CascadeDisableConfirmationDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  dependentModules: ModuleDependency[];
  onConfirm: () => void;
}

export function CascadeDisableConfirmationDialog({
  open,
  onOpenChange,
  dependentModules,
  onConfirm,
}: CascadeDisableConfirmationDialogProps) {
  const { t } = useTranslation();

  const satisfiedDependentModules = dependentModules.filter((d) => d.isSatisfied);

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            {t("integrations.modules.configure.cascadeDisable.title")}
          </AlertDialogTitle>
          <AlertDialogDescription>
            <Trans
              i18nKey="integrations.modules.configure.cascadeDisable.description"
              components={{ 1: <b /> }}
            />
            <ul className="list-disc list-inside mt-2">
              {satisfiedDependentModules.map((dep, index) => (
                <li key={index}>
                  {t(dep.moduleDisplayName ?? "", { defaultValue: dep.moduleDisplayName ?? "" })} (
                  {t(dep.integrationDisplayName ?? "", {
                    defaultValue: dep.integrationDisplayName ?? "",
                  })})
                </li>
              ))}
            </ul>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>{t("common.cancel")}</AlertDialogCancel>
          <AlertDialogAction variant="destructive" onClick={onConfirm}>
            {t("integrations.modules.configure.cascadeDisable.confirm")}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
